import clsx from 'clsx';
import { ImgHTMLAttributes } from 'react';

export const Image = ({
  src,
  className,
}: ImgHTMLAttributes<HTMLImageElement>) => (
  <img className={clsx('object-cover', className)} src={src} />
);
